var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showPrefixString)?[_vm._v("\n\t\t"+_vm._s(_vm.t('collectives', 'Last changed by'))+"\n\t")]:_vm._e(),_vm._v(" "),_c('NcUserBubble',{attrs:{"display-name":_vm.lastUserDisplayName,"user":_vm.lastUserId}}),_vm._v(" "),_c('span',{staticClass:"timestamp"},[_vm._v("\n\t\t"+_vm._s(_vm.lastUpdate)+"\n\t")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }